// Loyalty tier helper — aligned with backend /api/loyalty/tiers (single source of truth values).
// Backend: Bronz 0+, Gümüş 5+, Altın 15+, Platin 30+
const TIERS = [
  { key: 'bronze', label: 'Bronz', min: 0 },
  { key: 'silver', label: 'Gümüş', min: 5 },
  { key: 'gold', label: 'Altın', min: 15 },
  { key: 'platinum', label: 'Platin', min: 30 },
];

export const getLoyaltyTier = (totalOrders = 0) => {
  const n = Number(totalOrders) || 0;
  let current = TIERS[0];
  let next = null;
  for (let i = 0; i < TIERS.length; i++) {
    if (n >= TIERS[i].min) current = TIERS[i];
    else { next = TIERS[i]; break; }
  }
  const span = next ? Math.max(1, next.min - current.min) : 1;
  const progress = next ? Math.min(1, (n - current.min) / span) : 1;
  return {
    key: current.key,
    label: current.label,
    nextAt: next ? next.min : null,
    nextLabel: next ? next.label : null,
    progress
  };
};

export const TIER_COLORS = {
  bronze:   { from: '#E8B98A', to: '#8B5A2B', text: '#5C3A1F', label: 'Bronz' },
  silver:   { from: '#F2F2F2', to: '#A8A9AD', text: '#3C3D40', label: 'Gümüş' },
  gold:     { from: '#F5D061', to: '#B8860B', text: '#5A4407', label: 'Altın' },
  platinum: { from: '#E8F4F8', to: '#7AA0B8', text: '#1F3A4A', label: 'Platin' },
};
